// extracted by mini-css-extract-plugin
export default {"input":"Signup_input__-F+z1","header":"Signup_header__9DOug","Button":"Signup_Button__mxCJ2","a":"Signup_a__Zh+Au"};